import { getDivided } from "./numberUtils";
import { MosaicTransferable } from "nem-library";
export function createMosaicTransferableFrom(definition, quantity) {
    return MosaicTransferable.createWithMosaicDefinition(definition, getDivided(quantity, definition.properties.divisibility).toNumber());
}
export function createWithNewAmount(mosaic, amount) {
    return new MosaicTransferable(mosaic.mosaicId, mosaic.properties, amount, mosaic.levy);
}
export function getXemBookMosaicList() {
    return fetch("https://s3-ap-northeast-1.amazonaws.com/xembook.net/gallery/mosaic_list.json")
        .then((response) => {
        return response.json();
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/lib/mosaicUtils.ts
// module id = 187
// module chunks = 1